import { FeatureFlag } from '@sonar-software/sonar-core';
import { useFeatureFlag } from './useFeatureFlags';

export function usePardotEnabled(): boolean {
	return useFeatureFlag(FeatureFlag.PardotEnabled);
}
